import { ExternalLink, FileCheck } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { EDITABLE, SOURCES } from "@/data/content";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";

export default function Market() {
  const { t } = useLanguage();
  const m = t.mercado;

  return (
    <section id="mercado" className="border-y border-white/5 bg-[#0A0D14]" data-testid="mercado-section">
      <div className="mx-auto max-w-7xl scroll-mt-20 px-4 py-20 sm:px-6 sm:py-28 lg:px-8">
        <SectionHeader number={`${m.number} · ${t.nav.mercado}`} title={m.title} />

        <div className="grid gap-6 lg:grid-cols-2">
          <Reveal>
            <article className="flex h-full flex-col rounded-2xl border border-white/10 bg-[#131927]/80 p-7 sm:p-9" data-testid="market-value-card">
              <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-sky-400">
                {m.valueLabel}
              </p>
              <p className="mt-4 font-mono text-5xl font-bold tracking-tight text-white sm:text-6xl" data-testid="market-value-figure">
                {EDITABLE.marketValue}
              </p>
              <p className="mt-4 text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">
                {m.sourceLine}
              </p>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">{m.disclaimer}</p>
              <p className="mt-2 text-xs leading-relaxed text-slate-500">{m.altNote}</p>
              <a
                href={SOURCES.transfermarkt}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="market-source-link"
                className="mt-6 inline-flex w-fit items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.14em] text-slate-200 transition-colors duration-300 hover:border-sky-400/60 hover:text-sky-300"
              >
                <ExternalLink size={14} />
                {m.sourceCta}
              </a>
            </article>
          </Reveal>

          <Reveal delay={0.1}>
            <article className="flex h-full flex-col rounded-2xl border border-emerald-400/20 bg-[#0E131F] p-7 sm:p-9" data-testid="contract-card">
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-400/10">
                  <FileCheck size={17} className="text-emerald-400" />
                </span>
                <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-emerald-300">
                  {m.contractTitle}
                </p>
              </div>
              <ul className="mt-6 space-y-4">
                {m.contractLines.map((line, i) => (
                  <li key={line} className="flex items-baseline gap-3">
                    <span className={`h-1.5 w-1.5 shrink-0 translate-y-[-2px] rounded-full ${i === 0 ? "bg-emerald-400" : "bg-slate-600"}`} />
                    <span className={i === 0 ? "font-display text-2xl font-bold uppercase tracking-wide text-white sm:text-3xl" : "text-sm text-slate-400"}>
                      {line}
                    </span>
                  </li>
                ))}
              </ul>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
